<template>
    <div class="game-lobby">
        <div v-if="!gameId" class="create-game">
            <h2>Create New Game</h2>
            <input v-model="playerName" placeholder="Your name" />
            <button @click="handleCreateGame" :disabled="!playerName || loading">
                {{ loading ? 'Creating...' : 'Create Game' }}
            </button>
        </div>

        <div v-else class="join-game">
            <h2>Join Game</h2>
            <p>Game ID: {{ gameId }}</p>
            <input v-model="playerName" placeholder="Your name" />
            <button @click="handleJoinGame" :disabled="!playerName || loading">
                {{ loading ? 'Joining...' : 'Join Game' }}
            </button>
        </div>

        <div v-if="error" class="error-message">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useGameStore } from '@/stores/game'
import { useRouter } from 'vue-router'

export default {
    props: {
        gameId: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const gameStore = useGameStore()
        const router = useRouter()
        const playerName = ref('')
        const loading = computed(() => gameStore.loading)
        const error = computed(() => gameStore.error)

        const handleCreateGame = async () => {
            await gameStore.createGame(playerName.value)
            if (gameStore.gameId) {
                router.push({ name: 'game', params: { id: gameStore.gameId } })
            }
        }

        const handleJoinGame = async () => {
            await gameStore.joinGame(props.gameId, playerName.value)
            if (gameStore.gameId) {
                router.push({ name: 'game', params: { id: gameStore.gameId } })
            }
        }

        return {
            playerName,
            loading,
            error,
            handleCreateGame,
            handleJoinGame
        }
    }
}
</script>

<style scoped>
.game-lobby {
    max-width: 500px;
    margin: 0 auto;
    padding: 30px;
    background-color: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h2 {
    margin-top: 0;
    color: #333;
}

input {
    display: block;
    width: 100%;
    padding: 10px;
    margin: 15px 0;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 16px;
}

button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.error-message {
    margin-top: 20px;
    color: #dc3545;
    padding: 10px;
    background-color: #f8d7da;
    border-radius: 4px;
}
</style>